import { Box, Container, Grid, Typography } from '@mui/material';
import { AppBar } from '../components/AppBar';
import { UsageCard } from '../components/UsageCard';
import { ClientsSection } from '../components/ClientsSection';
import { ScanSection } from '../components/ScanSection';

export function Dashboard() {
  return (
    <Box>
      <AppBar />
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }}>
        <Typography variant="h2" sx={{ mb: 4 }}>Dashboard</Typography>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <ScanSection />
          </Grid>
          <Grid item xs={12} lg={7}>
            <ClientsSection />
          </Grid>
          <Grid item xs={12} lg={5}>
            <UsageCard />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}